
import { ArrowRight } from "lucide-react";
import { ContactButton } from "@/components/ui/button";

export const CtaSection = () => {
  return (
    <section className="py-16" aria-labelledby="cta-heading">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-2xl bg-edgefi-purple p-8 md:p-12 text-center shadow-lg">
          <h2 
            id="cta-heading"
            className="text-3xl font-bold mb-4 text-white"
          >
            Ready to Transform Your IT Experience?
          </h2>
          
          <p className="mb-8 max-w-2xl mx-auto text-purple-100">
            Take the first step toward predictable, reliable IT that supports your business goals rather than getting in your way.
          </p>
          
          <ContactButton 
            variant="default"
            size="lg"
            className="bg-white text-edgefi-purple hover:bg-purple-50 group"
            modalTitle="IT Assessment Request"
            modalDescription="Let's discuss how we can transform your IT experience and help your business thrive. Fill out the form below to schedule your free assessment."
            modalFormId="dfa977cc-c726-4029-89d1-d8f757482a67"
            additionalFields={{
              lead_source: "Website",
              lead_interest: "Managed IT Services",
              service_interest: "IT Assessment"
            }}
          >
            Schedule Your Free IT Assessment
            <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" aria-hidden="true" />
          </ContactButton>
        </div>
      </div>
    </section>
  );
};
